import useLabel from "@apps/use-label/use-label";
import Tooltip from "@components/tooltip/tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

const QuestionLockedByPrecalibration = () => {
  const label = useLabel();
  return (
    <Tooltip
      text={`This question's rating is locked because it was rated during "pre-${label(
        "review",
      )} calibration". Admins will still be able to edit ratings after this downward ${label(
        "review",
      )} is submitted.`}
    >
      <div className="px-2 py-1 bg-amber-100 rounded-sm w-fit flex items-center gap-2">
        <TopicflowIcon type="lockClosed" className="text-gray-500 h-4 w-4" />
        <div className="text-gray-500 text-xs">
          Rating for this question is locked
        </div>
      </div>
    </Tooltip>
  );
};

export default QuestionLockedByPrecalibration;
